import {useState} from "react";

export const useHandleSort = () => {
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);

  const handleSortSelect = (option) => {
    const [sortColumn, sortDirection] = option ? option.split("-") : [null, null];
    setSortColumn(sortColumn);
    setSortDirection(sortDirection);
  };

  const handleSortClick = (column) => {
    if (!sortDirection) {
      setSortDirection("asc");
      setSortColumn(column);
      return;
    }
    if (sortColumn !== column) {
      setSortDirection("asc");
      setSortColumn(column);
      return;
    }
    setSortDirection(sortDirection === "asc" ? "desc" : null);
    setSortColumn(sortDirection === "asc" ? column : null);
  };

  return {handleSortClick, handleSortSelect, sortColumn, sortDirection};
};
